module.exports = __webpack_public_path__ + "img/4.b6489da6.jpg";